import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import SourcedFrom from "../common/SourcedFrom";

export default () => {
  const data = useStaticQuery(graphql`
    query {
      allHyperStatsCsv {
        nodes {
          level
          cost
          final_dmg_pct
          max_dmg_inc
          phy_dmg_pct
          mag_dmg_pct
          crit_rate_pct
          crit_dmg_pct
          boss_atk_pct
          exp_pct
          sf_inc
          party_exp_pct
          kbk
          fever_dur_inc
          item_buff_dur
          additional_dmg
          atk_ignore_rate_pct
        }
      }
    }
  `);

  const hyperStats = data.allHyperStatsCsv.nodes;
  return (
    <div>
      <SourcedFrom />
      <h5 className="subtitle">Hyper Stats Cost table</h5>
      <div className="table-container">
        <Table className="table is-hoverable">
          <Thead>
            <Tr>
              <Th>Level</Th>
              <Th>Cost (Meso)</Th>
              <Th>Final Dmg %</Th>
              <Th>Max DMG Inc</Th>
              <Th>Phy DMG %</Th>
              <Th>Mag DMG %</Th>
              <Th>Crit Rate %</Th>
              <Th>Crit DMG %</Th>
              <Th>Boss ATK %</Th>
              <Th>EXP %</Th>
              <Th>SF Increase</Th>
              <Th>Party EXP %</Th>
              <Th>KBK</Th>
              <Th>Fever Duration Inc</Th>
              <Th>Item Buff Duration Inc</Th>
              <Th>Chance for Add. DMG (%,%)</Th>
              <Th>Atk Ignore Rate %</Th>
            </Tr>
          </Thead>
          <Tbody>
            {hyperStats.map((node, index) => {
              return (
                <Tr key={index}>
                  {Object.values(node).map((value) => (
                    <Td>{value}</Td>
                  ))}
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      </div>
    </div>
  );
};
